import React, { useEffect, useState } from 'react';
import { useHunterFarmerList } from '@/api/auth/useHunterFarmerList';

const Filters = ( {onFilterChange} ) => {

    const [selectedProduct, setSelectedProduct] = useState([]);
    const [selectedChurnLikelihood, setSelectedChurnLikelihood] = useState([]);
    const [selectedRelationship, setSelectedRelationship] = useState([]);
    const [selectedProfileName, setSelectedProfileName] = useState([]);
    const [selectedFarmer, setSelectedFarmer] = useState([])

    const {farmerListAPI} = useHunterFarmerList()
    // Churn Likelihood, Product, Relationship, Profile Name, More
    const churnLikelihoodOptions = [
        { id: 1, label: 'Activated' },
        { id: 2, label: 'Dormant' },
        { id: 3, label: 'Sabik' },
        { id: 4, label: 'Sirius' },
        { id: 5, label: 'Spica' },
        { id: 6, label: 'Sargas' },
    ];

    const productsOptions = [
        { id: 1, label: 'Remittance' },
        { id: 2, label: 'Insurance' },
        { id: 3, label: 'Re-KYC' },
        { id: 4, label: 'Referral' },
        { id: 5, label: 'Financing' },
    ];

    const relationshipOptions = [
        { id: 1, label: 'Cold' },
        { id: 2, label: 'Warm' },
        { id: 3, label: 'Hot' }
    ];

    const profileNameOptions = [
        { id: 1, label: 'Core Customer (Loyal)' },
        { id: 2, label: 'Farmable (Avg. Margins)' },
        { id: 3, label: 'Growth Potential' },
        { id: 4, label: 'Need Based (Avg. Margins)' },
        { id: 5, label: 'Farmable (Tight)' },
        { id: 6, label: 'Farmable (Loose)' },
        { id: 7, label: 'Newbie' },
        { id: 8, label: 'Fresh Meat' },
        { id: 9, label: 'Bargain Hunter' },
        { id: 10, label: 'Need Based (Tight)' },
        { id: 11, label: 'Need Based (Loose)' },
        { id: 12, label: 'Core Customer (EX-GF)' },
        { id: 13, label: 'Losers' },
        { id: 14, label: 'Dormant' },
        { id: 15, label: 'Wanderer' }
    ];


    const handleToggleProduct = (optionId) => {
        setSelectedProduct(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };

    const handleToggleRelationship = (optionId) => {
        setSelectedRelationship(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleChurnLikelihood = (optionId) => {
        setSelectedChurnLikelihood(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleProfileName = (optionId) => {
        setSelectedProfileName(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleFarmerList = (optionId) => {
      setSelectedFarmer(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
      );
    };


    const Dropdown = ({ 
        label, 
        selected, 
        options, 
        handleToggle, 
        onClear 
      }) => (
        <div className="relative group">
          <button
            className="px-4 py-2 bg-transparent hover:bg-yellow-100 rounded-lg
                       flex items-center space-x-2 font-medium text-gray-700
                       transition-colors duration-200"
          >
            <span>{label}</span>
            {selected.length > 0 && (
              <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 
                              bg-yellow-100 text-yellow-700 text-xs font-medium rounded-full">
                {selected.length}
              </span>
            )}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-4 h-4 transition-transform duration-200 ${
                'group-hover:rotate-180'
            }`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
    
          <div className="absolute left-0 mt-2 w-48 bg-white/80 backdrop-blur-sm border border-gray-200 
                          rounded-lg shadow-lg py-2 z-50 invisible group-hover:visible
                          transition-all duration-200 opacity-0 group-hover:opacity-100">
            {options.map((option) => (
              <label
                key={option.id}
                className="flex items-center px-4 py-2 hover:bg-yellow-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(option.id)}
                  onChange={() => handleToggle(option.id)}
                  className="h-4 w-4 rounded border-gray-300 text-yellow-500 
                             focus:ring-yellow-500 cursor-pointer"
                />
                <span className="ml-3 text-gray-700">{option.label || option?.username}</span>
              </label>
            ))}
            
            {selected.length > 0 && (
              <div className="border-t border-gray-200 mt-2 pt-2 px-4">
                <button
                  onClick={onClear}
                  className="text-sm text-yellow-600 hover:text-yellow-700"
                >
                  Clear all
                </button>
              </div>
            )}
          </div>
        </div>
    );

    useEffect(() => {
        const selectedFilters = {
            churnlikelihood: selectedChurnLikelihood,
            products: selectedProduct,
            relationship: selectedRelationship,
            profilename: selectedProfileName,
            farmer: selectedFarmer
        };

        onFilterChange(selectedFilters);
    }, [selectedChurnLikelihood, selectedProduct, selectedRelationship, selectedProfileName, selectedFarmer]);

    return(
        <div>
            <h1 className="font-bold pb-4">Quick Filter</h1>
            <div className="flex flex-row justify-between items-center">
                <p className="font-bold text-gray-500">Filter by:</p>
                <Dropdown 
                    label="Churn Likelihood"
                    selected={selectedChurnLikelihood}
                    options={churnLikelihoodOptions}
                    handleToggle={handleToggleChurnLikelihood}
                    onClear={() => setSelectedChurnLikelihood([])}
                />
                <Dropdown 
                    label="Product"
                    selected={selectedProduct}
                    options={productsOptions}
                    handleToggle={handleToggleProduct}
                    onClear={() => setSelectedProduct([])}
                />
                <Dropdown
                    label="Relationship"
                    selected={selectedRelationship}
                    options={relationshipOptions}
                    handleToggle={handleToggleRelationship}
                    onClear={() => setSelectedRelationship([])}
                />
                <Dropdown
                    label="Profile Name"
                    selected={selectedProfileName}
                    options={profileNameOptions}
                    handleToggle={handleToggleProfileName}
                    onClear={() => setSelectedProfileName([])}
                />
                <Dropdown
                    label="Owner"
                    selected={selectedFarmer}
                    options={farmerListAPI}
                    handleToggle={handleToggleFarmerList}
                    onClear={() => setSelectedFarmer([])}
                />
                 <button 
                 onClick={() => {
                    setSelectedChurnLikelihood([]);
                    setSelectedProduct([]);
                    setSelectedRelationship([]);
                    setSelectedProfileName([]);
                    setSelectedFarmer([]);
                }}
                 className="px-4 py-2 bg-transparent hover:bg-yellow-100 rounded-lg
                            flex items-center space-x-2 font-bold text-gray-700
                            underline transition-colors duration-200"
                 >Clear Filters
                 </button>
            </div>
        </div>
    )
}

export default Filters;
